import { FC } from "react";
import { MDSTextColor, MDSTextOverflow, MDSTextVariant } from "@/mds";
import { MdsIcon } from "@/design-system/components/icon/MdsIcon";
import { MdsIconKind } from "@/design-system/components/icon/types";
import { StyledChip, StyledIconContainer, StyledLabelText } from "@/components/chips/chip.style";

interface NoteChipProps {
  title: string;
  inline?: boolean;
}

export const NoteChip: FC<NoteChipProps> = ({ title, inline }) => (
  <StyledChip $inline={inline}>
    <StyledIconContainer $inline={inline}>
      <MdsIcon kind={MdsIconKind.Document} />
    </StyledIconContainer>
    {inline && " "}
    <StyledLabelText
      $inline={inline}
      variant={MDSTextVariant.HeaderL}
      color={MDSTextColor.Contrast}
      overflow={MDSTextOverflow.Ellipsis}
    >
      {title}
    </StyledLabelText>
  </StyledChip>
);
